import {
    CLEAR_ATTENDENCE, CLEAR_ATTENDENCE_FILTER,
    GET_ATTENDENCE, GET_ATTENDENCE_FAILURE,
    GET_ATTENDENCE_PROPERTIES, GET_ATTENDENCE_PROPERTIES_FAILURE, GET_ATTENDENCE_PROPERTIES_SUCCESS,
    GET_ATTENDENCE_SCHEDULES, GET_ATTENDENCE_SCHEDULES_FAILURE, GET_ATTENDENCE_SCHEDULES_SUCCESS,
    GET_ATTENDENCE_SUCCESS,
    GET_ATTENDENCE_USERS, GET_ATTENDENCE_USERS_FAILURE, GET_ATTENDENCE_USERS_SUCCESS,
    GET_SIDEBAR_USERS, GET_SIDEBAR_USERS_FAILURE, GET_SIDEBAR_USERS_SUCCESS,
    GET_ATTENDENCE_BY_USER,
    APPROVE_ATTENDANCE, APPROVE_ATTENDANCE_SUCCESS, APPROVE_ATTENDANCE_FAILURE,
} from "../constants";

export default class AttendenceManagementAction {
    static GetAttendence(payload) {
        return {
            type: GET_ATTENDENCE,
            payload
        }
    }
    static GetAttendenceSuccess(payload, filters) {
        return {
            type: GET_ATTENDENCE_SUCCESS,
            payload,
            filters
        }
    }
    static GetAttendenceFailure(isSubscriptionError) {
        return {
            type: GET_ATTENDENCE_FAILURE,
            payload: isSubscriptionError
        }
    }
    static GetAttendenceProperties(payload, cb) {
        return {
            type: GET_ATTENDENCE_PROPERTIES,
            payload,
            cb
        }
    }
    static GetAttendencePropertiesSuccess(payload) {
        return {
            type: GET_ATTENDENCE_PROPERTIES_SUCCESS,
            payload
        }
    }
    static GetAttendencePropertiesFailure() {
        return {
            type: GET_ATTENDENCE_PROPERTIES_FAILURE
        }
    }
    static GetAttendenceSchedules(payload) {
        return {
            type: GET_ATTENDENCE_SCHEDULES,
            payload
        }
    }
    static GetAttendenceSchedulesSuccess(payload) {
        return {
            type: GET_ATTENDENCE_SCHEDULES_SUCCESS,
            payload
        }
    }
    static GetAttendenceSchedulesFailure() {
        return {
            type: GET_ATTENDENCE_SCHEDULES_FAILURE
        }
    }
    static GetAttendenceUsers(payload) {
        return {
            type: GET_ATTENDENCE_USERS,
            payload
        }
    }
    static GetAttendenceUsersSuccess(payload) {
        return {
            type: GET_ATTENDENCE_USERS_SUCCESS,
            payload
        }
    }
    static GetAttendenceUsersFailure() {
        return {
            type: GET_ATTENDENCE_USERS_FAILURE
        }
    }
    static ClearAttendenceFilter() {
        return {
            type: CLEAR_ATTENDENCE_FILTER,
        }
    }
    static ClearAttendence(){
        return{
            type: CLEAR_ATTENDENCE
        }
    }

    // v2: sidebar user list (date-range only, no property/schedule required)
    static GetSidebarUsers(payload) {
        return { type: GET_SIDEBAR_USERS, payload }
    }
    static GetSidebarUsersSuccess(payload) {
        return { type: GET_SIDEBAR_USERS_SUCCESS, payload }
    }
    static GetSidebarUsersFailure(isSubscriptionError) {
        return { type: GET_SIDEBAR_USERS_FAILURE, payload: isSubscriptionError }
    }

    // v2: load attendance by userId + dateRange (no property/schedule required)
    static GetAttendenceByUser(payload) {
        return { type: GET_ATTENDENCE_BY_USER, payload }
    }

    // Attendance Approval
    static ApproveAttendance(payload) {
        return { type: APPROVE_ATTENDANCE, payload };
    }
    static ApproveAttendanceSuccess(payload) {
        return { type: APPROVE_ATTENDANCE_SUCCESS, payload };
    }
    static ApproveAttendanceFailure() {
        return { type: APPROVE_ATTENDANCE_FAILURE };
    }
}